module.exports = __webpack_public_path__ + "static/media/skitchin1.37192077.gif";